module.exports = __webpack_public_path__ + "img/stone11.4257d3e4.png";